/* Bazar360 · Producto en acción: botón que abre el formulario de compra (Releasit) y videos que solo corren cuando se ven */
(() => {
  const openBuy = () => {
    const trigger = document.querySelector(
      '._rsi-buy-now-button, .product-form__buttons ._rsi-buy-now-button, product-info ._rsi-buy-now-button'
    );
    if (trigger) { trigger.click(); return; }
    const submit = document.querySelector('product-form form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [type="submit"]');
    if (submit) { submit.click(); return; }
    const info = document.querySelector('product-info, .product');
    if (info) info.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  document.addEventListener('click', (e) => {
    const buy = e.target.closest('[data-pa-buy]');
    if (buy) { e.preventDefault(); openBuy(); }
  });

  const io = 'IntersectionObserver' in window && new IntersectionObserver((entries) => {
    entries.forEach((en) => { const v = en.target; if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); });
  }, { threshold: 0.25 });
  const watch = () => document.querySelectorAll('video.b360-pa__video, .b360-pa__season-media video').forEach((v) => {
    v.setAttribute('playsinline', ''); v.muted = true; if (io) io.observe(v);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* LumiFiestas: oculta el bloque blanco de reseñas de la app (sin reseñas todavía) solo en esta plantilla */
(() => {
  const hide = () => {
    document.querySelectorAll('[id*="trustoo" i],[class*="trustoo" i],[id*="vstar" i],[class*="vstar" i]').forEach((el) => {
      if (!el.closest('.b360-pa')) el.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('h1,h2,h3,h4,div,span').forEach((el) => {
      if (el.children.length > 2) return;
      const t = (el.textContent || '').trim();
      if (t !== 'Customer Reviews' && t !== 'Reseñas de clientes') return;
      let box = el;
      for (let i = 0; i < 8 && box.parentElement; i++) {
        const p = box.parentElement;
        if (p === document.body || p.tagName === 'MAIN' || p.classList.contains('shopify-section') || p.id === 'MainContent') break;
        box = p;
        if (/write a review|escribir una reseña/i.test(box.textContent || '')) break;
      }
      if (!box.closest('.b360-pa')) box.style.setProperty('display', 'none', 'important');
    });
  };
  const run = () => {
    hide();
    const mo = new MutationObserver(hide);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 15000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
